"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _modals = require("../../../utils/modals");
var _constants = require("../../Terms/constants");
var _TermsModal = _interopRequireDefault(require("./TermsModal"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mapStateToProps = function mapStateToProps(state, _ref) {
  var asset = _ref.asset;
  var isPortalLoading = _exchangeUiPortalsStore.selectors.selectIsPortalLoading(state);
  var termsMarkdown = _exchangeUiPortalsStore.selectors.selectPageMarkdown(state, _objectSpread(_objectSpread({}, asset), {}, {
    pagePath: _constants.TERMS_PAGE_PATH
  }));
  return {
    asset: asset,
    isPortalLoading: isPortalLoading,
    termsMarkdown: termsMarkdown
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var asset = _ref2.asset;
  return {
    onComponentMounted: function onComponentMounted() {
      return dispatch(_exchangeUiPortalsStore.actions.getPageMarkdown(_objectSpread(_objectSpread({}, asset), {}, {
        pagePath: _constants.TERMS_PAGE_PATH
      })), {
        skipErrorHandler: function skipErrorHandler(error) {
          return error.status === 404;
        }
      });
    }
  };
};
var TermsModalContainer = (0, _redux.compose)((0, _modals.setModalName)('TermsModal'), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_TermsModal.default);
var _default = exports.default = TermsModalContainer;
//# sourceMappingURL=TermsModal.container.js.map